import {PURGE} from 'redux-persist';
import {actions as A} from '../constants/actions';

const defaultState = {
  accessToken: null,
  expire: null,
  idToken: null,
  refreshToken: null,
  loading: false,
  error: false,
  errorMessage: null,
  receivedAt: null,
};

export const authReducer = (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.LOGIN:
      return {...state, loading: true};

    case A.LOGIN_SUCCESS:
      const {tokens} = payload;
      if (tokens.receivedAt >= state.receivedAt) {
        return {...state, loading: false, ...tokens};
      } else {
        return {...state, loading: false};
      }

    case A.LOGIN_FAILURE:
      const {errorMessage} = payload;
      return {...state, loading: false, error: true, errorMessage};

    case A.REFRESH_TOKEN:
      return {...state, loading: true};

    case A.LOGOUT:
    case PURGE:
      return defaultState;

    default:
      return state;
  }
};
